import { Link } from "react-router-dom";
export default function NotFound() {
    return (
        <div className="min-h-[60vh] flex items-center justify-center px-4">
            <div className="text-center">
                <div className="number-eyebrow mb-4">404</div>
                <h1 className="font-display text-4xl sm:text-5xl font-bold text-stone-900 mb-4">Página não encontrada</h1>
                <p className="text-stone-600 mb-8">A página que procura não existe ou foi movida.</p>
                <Link to="/" className="btn-ochre inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold">Voltar ao início</Link>
            </div>
        </div>
    );
}
